import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import useViewportSizes from './useViewportSizes';
/**
 * The internal textarea from CL will be set with the given max height value, but it also adds some padding external from that element
 * This will be removed from the max height calculation in this component
 */
var TEXTAREA_PADDING = 55;
/**
 * These height values are derived from this design spec:
 * https://www.figma.com/design/Oz2jagFisJ8DW9woTZEtlG/DDS-[Audit]-Components?node-id=829-4070&t=4JRQ97Hfjm2RvLDf-0
 */
var DESKTOP_250_MAX_CHAR_HEIGHT = 148;
var DESKTOP_1000_MAX_CHAR_HEIGHT = 364;
var useTextareaSizing = function (_a) {
    var maximumCharacters = _a.maximumCharacters;
    var isMobile = useWindowSize().isLessThanTablet;
    var viewportHeight = useViewportSizes().viewportHeight;
    if (isMobile) {
        return {
            maxHeight: Math.floor(viewportHeight * 0.5) - TEXTAREA_PADDING
        };
    }
    return {
        maxHeight: (maximumCharacters <= 250
            ? DESKTOP_250_MAX_CHAR_HEIGHT
            : DESKTOP_1000_MAX_CHAR_HEIGHT) - TEXTAREA_PADDING
    };
};
export default useTextareaSizing;
//# sourceMappingURL=useTextareaSizing.js.map